"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input } from "rizzui";

export default function CollegeFooterEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  const socialLinks = content.socialLinks || [];

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Footer Text</h4>
            <TextEditor
              label="Brand Name"
              value={content.companyName}
              onChange={(v) => updateContent("companyName", v)}
              placeholder="COLLEGE"
            />
            <TextEditor
              label="Copyright Text"
              value={content.copyright}
              onChange={(v) => updateContent("copyright", v)}
              placeholder="© 2026 Instacks. All rights reserved."
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Social Links</h4>
            {["facebook", "twitter", "instagram", "linkedin"].map((platform) => {
              const existingLink = socialLinks.find((s: any) => s.platform === platform);
              return (
                <div key={platform} className="flex items-center gap-2">
                  <span className="w-20 text-xs text-gray-600 capitalize font-medium">{platform}</span>
                  <Input
                    value={existingLink?.url || ""}
                    onChange={(e) => {
                      const newLinks = [...socialLinks.filter((s: any) => s.platform !== platform)];
                      if (e.target.value) {
                        newLinks.push({ platform, url: e.target.value });
                      }
                      updateContent("socialLinks", newLinks);
                    }}
                    placeholder={`https://${platform}.com/...`}
                    className="!rounded-lg flex-1 text-xs h-8"
                  />
                </div>
              );
            })}
          </div>
        </div>
      }
    />
  );
}
